import { AxMachine } from './AxMachine';
import countries from '@/assets/countries.json';


export interface IAxProject {
    /**
     * ISO 2 letter country code
     */
    countryCode: string;
    /**
     * Country name matching the {@link countryCode}
     */
    countryName: string;
    /**
     * Address of the project location
     */
    address: string;
    /**
     * Project number
     */
    projectNumber: string;
    /**
     * List of machines in the project
     */
    machines: AxMachine[];
}

export class AxProject implements IAxProject {
    public countryCode: string;
    public countryName: string;
    public address: string;
    public projectNumber: string;
    public machines: AxMachine[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IAxProject);
    constructor(obj?: any) {
        this.countryCode = obj && obj.countryCode || '';
        this.countryCode = obj && obj.countryCode || '';
        this.address = obj && obj.address || '';
        this.projectNumber = obj && obj.projectNumber || '';
        this.machines = [];
        if (obj && obj.machines) {
            obj.machines.forEach((machine: AxMachine) => {
                this.machines.push(new AxMachine(machine));
            });
        }

        this.countryName = this.getCountryName(this.countryCode);
    }

    private getCountryName(inCountryCode: string): string {
        let country = 'unknown';
        const countryItem = (countries as Array<{ id: string, name: string }>).find((item) => item.id === inCountryCode);
        if (countryItem !== undefined) {
            country = countryItem.name;
        }
        return country;
    }
}
